/**
 * @generated SignedSource<<2d43aa77cfdbd36479ce1c3246733627>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateTasksBulkInput = {
  tasks?: ReadonlyArray<TaskBulk | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type TaskBulk = {
  taskId?: string | null;
  roleId?: string | null;
  estimateLow?: number | null;
  estimateHigh?: number | null;
  estimateForecast?: number | null;
  personIds?: ReadonlyArray<string | null> | null;
  labelIds?: ReadonlyArray<string | null> | null;
};
export type updateTasksBulkMutationModernMutation$variables = {
  input: UpdateTasksBulkInput;
};
export type updateTasksBulkMutationModernMutation$data = {
  readonly updateTasksBulk: {
    readonly tasks: ReadonlyArray<{
      readonly id: string;
      readonly estimateForecast: number | null;
      readonly estimateForecastMinutes: number | null;
      readonly estimateForecastPrice: number | null;
      readonly timeLeft: number | null;
      readonly role: {
        readonly id: string;
        readonly name: string | null;
      } | null;
      readonly assignedPersons: ReadonlyArray<{
        readonly id: string;
        readonly active: boolean | null;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly profilePictureId: string | null;
        readonly profilePictureDefaultId: number | null;
        readonly permissions: ReadonlyArray<string | null> | null;
        readonly client: {
          readonly id: string;
        } | null;
      } | null> | null;
      readonly taskLabels: ReadonlyArray<{
        readonly id: string;
        readonly label: {
          readonly id: string;
          readonly name: string | null;
          readonly color: string | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};
export type updateTasksBulkMutationModernMutation = {
  variables: updateTasksBulkMutationModernMutation$variables;
  response: updateTasksBulkMutationModernMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateTasksBulkPayload",
    "kind": "LinkedField",
    "name": "updateTasksBulk",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "tasks",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimateForecast",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimateForecastMinutes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimateForecastPrice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeLeft",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Role",
            "kind": "LinkedField",
            "name": "role",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "assignedPersons",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "active",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "profilePictureId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "profilePictureDefaultId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "permissions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Client",
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskLabel",
            "kind": "LinkedField",
            "name": "taskLabels",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Label",
                "kind": "LinkedField",
                "name": "label",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateTasksBulkMutationModernMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateTasksBulkMutationModernMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "800eaef0e4b73900791c264fc89176d3",
    "id": null,
    "metadata": {},
    "name": "updateTasksBulkMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation updateTasksBulkMutationModernMutation(\n  $input: UpdateTasksBulkInput!\n) {\n  updateTasksBulk(input: $input) {\n    tasks {\n      id\n      estimateForecast\n      estimateForecastMinutes\n      estimateForecastPrice\n      timeLeft\n      role {\n        id\n        name\n      }\n      assignedPersons {\n        id\n        active\n        firstName\n        lastName\n        profilePictureId\n        profilePictureDefaultId\n        permissions\n        client {\n          id\n        }\n      }\n      taskLabels {\n        id\n        label {\n          id\n          name\n          color\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4d9040af6c4db36dce16cc7ee40f25a7";

export default node;
